import type { HTMLChakraProps } from '@chakra-ui/react';
import { forwardRef, useMultiStyleConfig } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

import {
  MessageGroupStyles,
  MessageGroupStylesProvider,
} from '../useMessageGroupStyles';

export type MessageGroupProps = HTMLChakraProps<'div'>;

/**
 * MessageGroup is a container for displaying user messages and agent message content.
 */
export const MessageGroup: React.FC<MessageGroupProps> = forwardRef<
  MessageGroupProps,
  'div'
>(({ children, ...props }, ref) => {
  const messageGroupStyles = useMultiStyleConfig(
    'MessageGroup',
  ) as MessageGroupStyles;

  return (
    <MessageGroupStylesProvider value={messageGroupStyles}>
      <chakra.div
        sx={messageGroupStyles.container}
        className="message-group"
        {...props}
        ref={ref}
      >
        {children}
      </chakra.div>
    </MessageGroupStylesProvider>
  );
});
MessageGroup.displayName = 'MessageGroup';
